/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
import { useCallback } from 'react';

interface ButtonGroupOption {
  value: any;
  label: string;
}

interface ButtonGroupProps {
  value?: any;
  onChange?: (value: any) => void;
  multiple?: boolean;
  clearable?: boolean;
  disabled?: boolean;
  required?: boolean;
  options?: ButtonGroupOption[];
  'data-cy'?: string;
}

function ButtonGroup({
  value = null,
  onChange = () => {},
  multiple = false,
  clearable = false,
  disabled = false,
  required = false,
  options = [],
  'data-cy': dataCy = '',
}: ButtonGroupProps) {
  const handleChange = useCallback(
    (val: any) => {
      if (multiple) {
        if (!Array.isArray(value)) {
          onChange([val]);
        } else if (value.includes(val)) {
          const newValue = value.filter((v) => v !== val);

          if (clearable || newValue.length > 0) {
            onChange(newValue);
          }
        } else {
          onChange([...value, val]);
        }
      } else {
        onChange(val);
      }
    },
    [onChange, multiple, clearable, value]
  );

  return (
    <span className="relative z-0 inline-flex shadow-sm rounded-lg">
      {options.map(({ value: val, label }: ButtonGroupOption, index: number) => {
        let selected = false;

        if (multiple) {
          selected = Array.isArray(value) && value.includes(val);
        } else {
          selected = val === value;
        }

        let className =
          'relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500';
        if (index !== 0) {
          className = `-ml-px ${className}`;
        }
        if (index === 0) {
          className = `rounded-l-lg ${className}`;
        }
        if (index === options.length - 1) {
          className = `rounded-r-lg ${className}`;
        }

        if (selected) {
          className +=
            ' border-primary text-primary z-10 outline-none ring-1 ring-secondary-500 border-secondary-500';
        }

        return (
          <button
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            type="button"
            onClick={() => {
              handleChange(val);
            }}
            className={className}
            disabled={disabled}
            data-cy={dataCy}
          >
            {label}
          </button>
        );
      })}
    </span>
  );
}

export default ButtonGroup;
